import { render, staticRenderFns } from "./_MessageTemplate.vue?vue&type=template&id=430eefba&"
import script from "./_MessageTemplate.vue?vue&type=script&lang=js&"
export * from "./_MessageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./_MessageTemplate.vue?vue&type=style&index=0&id=430eefba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports